<div class="driver-view-container" *ngIf="adminView">
  <div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
  </div>
  <div class="driver-view">
    <div class="heading">
      <h3>Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <div class="row m-0">
      <div class="col-sm-9">
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-6">
            <div class="head">Name</div>
            <div class="dec">
              {{ adminData.adminRegisterDetails.name }}
            </div>
          </div>
          <div class="col-sm-6">
            <div class="head">Username</div>
            <div class="dec">
              {{ adminData.username }}
            </div>
          </div>
        </div>
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-6">
            <div class="head">Mobile</div>
            <div class="dec">
              {{ adminData.mobile }}
              <img src="../../../assets/img/tick-verify.svg" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="head">Email</div>
            <div class="dec">
              {{ adminData.email }}
              <img src="../../../assets/img/tick-verify.svg" />
            </div>
          </div>
        </div>
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-6">
            <div class="head">Gender</div>
            <div class="dec">{{ adminData.adminRegisterDetails.gender | titlecase }}</div>
          </div>
          <div class="col-sm-6">
            <div class="head">DOB</div>
            <div class="dec">{{ adminData.adminRegisterDetails.dob | date: 'dd-MM-yyyy' }}</div>
          </div>
        </div>
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-6">
            <div class="head">Employee ID</div>
            <div class="dec">{{ adminData.adminRegisterDetails.employee_id }}</div>
          </div>
          <div class="col-sm-6">
            <div class="head">Role</div>
            <div class="dec">{{ adminData.adminRegisterDetails.role }}</div>
          </div>
        </div>
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-6">
            <div class="head">SMS Notifications</div>
            <div class="dec">
              <span [style.color]="adminData.adminRegisterDetails.is_sms_enabled ? 'green' : 'grey'"
                style="font-weight: 600;">
                {{ adminData.adminRegisterDetails.is_sms_enabled ? 'Enabled' : 'Disabled' }}
              </span>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="head">Account Status</div>
            <div class="dec">
              <span [style.color]="adminData.adminRegisterDetails.is_active !== false ? 'green' : 'red'"
                style="font-weight: 600;">
                {{ adminData.adminRegisterDetails.is_active !== false ? 'Active' : 'Deactivated' }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-6">
            <div class="head">Permissions</div>
            <div class="dec">
              <div style="font-size: 16px; display: flex; flex-wrap: wrap; gap: 5px;">
                <span *ngFor="let permId of adminData.adminRegisterDetails.permissions"
                  style="background: #eef; padding: 2px 8px; border-radius: 4px; border: 1px solid #ccf;">
                  {{ getModuleName(permId) }}
                </span>
                <span
                  *ngIf="!adminData.adminRegisterDetails.permissions || adminData.adminRegisterDetails.permissions.length === 0"
                  style="color: grey; font-style: italic;">
                  None
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="row">
          <div class="col-sm-10 right-side">
            <img src="{{ adminData.adminRegisterDetails.profile_pic }}" />
            <div class="head text-center mt-2">{{ adminData.username }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mtb">
      <div class="col-sm-11">
        <div class="fixed-btn">
          <button class="button" (click)="editUsers()">Edit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ---------------------- Edit user ------------------- -->

<div *ngIf="!adminView" class="driver-view-container">
  <div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
  </div>
  <div class="driver-view">
    <div class="heading">
      <h3>Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <form class="admin-forms mt-3" [formGroup]="adminFormGroup">
      <div class="row mtb input-fileds-container">
        <div class="col-sm-8">
          <!-- Row 1: EID and Name -->
          <!-- Row 1: EID and Name -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Emp ID</mat-label>
                <input matInput formControlName="employee_id" required />
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" (keypress)="validateAlphabetsAndSpaces($event)" required />
                <mat-error *ngIf="adminFormGroup.get('name')?.hasError('required')">Please enter name</mat-error>
                <mat-error *ngIf="adminFormGroup.get('name')?.hasError('pattern')">Only alphabets and spaces allowed</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Row 1.5: Username -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Username</mat-label>
                <input matInput formControlName="username" (keypress)="validateAlphaNumeric($event)" required />
                <mat-error *ngIf="adminFormGroup.get('username')?.hasError('required')">Please enter username</mat-error>
                <mat-error *ngIf="adminFormGroup.get('username')?.hasError('pattern')">Only alphanumeric characters allowed</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Row 2: Email and Mobile -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" required />
                <mat-error>Please enter email</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Mobile</mat-label>
                <input matInput formControlName="mobile" required />
                <mat-error>Please enter mobile</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Row 3: DOB and Gender -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>DOB</mat-label>
                <input matInput [matDatepicker]="picker1" [max]="minDob" formControlName="dob"
                  (change)="onDateChnage(2)" required />
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error> Date of birth is required</mat-error>
                <mat-error *ngIf="invalidDob">Please select valid Date of birth</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Gender</mat-label>
                <mat-select formControlName="gender">
                  <mat-option>Select Gender</mat-option>
                  <mat-option value="male">Male</mat-option>
                  <mat-option value="female">Female</mat-option>
                  <mat-option value="others">Others</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <!-- Row 4: Role and SMS Toggle -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Role</mat-label>
                <input matInput formControlName="role" required />
              </mat-form-field>
            </div>
            <div class="col-sm-6 d-flex align-items-center">
              <mat-slide-toggle formControlName="is_sms_enabled" labelPosition="before">
                Enable SMS for Quote Notifications
              </mat-slide-toggle>
            </div>
          </div>
          <div class="row mtb">
            <div class="col-sm-6 d-flex align-items-center">
              <mat-slide-toggle formControlName="is_active" labelPosition="before" color="primary">
                Active Account
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="row">
            <div class="col-sm-10 right-side">
              <img src="{{ profile_pic }}" />
              <div class="image-upload-area">
                <input #uploadImage type="file" (change)="onChange($event)" hidden />
              </div>
              <span class="head" (click)="uploadImage.click()">Change Profile Picture
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Permissions Area -->
      <div class="permissions-container mt-3">
        <h6>Module Permissions</h6>
        <div class="modules-grid">
          <div *ngFor="let module of adminModules" class="module-item">
            <mat-checkbox [checked]="selectedModules.includes(module.id)" (change)="toggleModule(module.id)">
              {{ module.name }}
            </mat-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-11">
          <div class="fixed-btn">
            <button class="button" (click)="updateAdmin()" [disabled]="isLoading">Save</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>